/**
 * @param {*} value
 * @param {string} country
 * @param {number|null} [bank]
 * @returns {string|undefined}
 */
function accountNo (value, country, bank = null) {
  return require('./locales')?.[country]?.accountNo(value, bank) || ''
}

module.exports = { accountNo }
